import translateUtils from "./TranslateUtils";

const TranslatedJsonService = function () {
    const service = this;

    function getUrl(accu) {
        const cacheBustEveryFifteenMinutes = Math.floor(Date.now() / 900000);
        const url =
            translateUtils.getCustomizationPath(accu) +
            "en_US.json?v=" +
            cacheBustEveryFifteenMinutes;

        return url;
    }

    function getTranslatedJSON($, accu, callback) {
        $.getJSON(getUrl(accu), function (json) {
            callback(json);
        }).fail(function (e) {
            if (e) {
                callback("error");
            }
        });
    }

    service.getUrl = getUrl;
    service.getTranslatedJSON = getTranslatedJSON;
};

export default TranslatedJsonService;
